import { SportsEnum, VenueAccessTypesEnum, VenueNetsEnum } from 'types/generated/client';

export type {
  FindCourtType,
  FindGame,
  FindGamePlayer,
  FindGameOrganizer,
  FindGameAudience,
  FindVenueDetails,
  FindGameDetails,
  PlayerGender,
  FindPlayerNeighborhood,
  FindPlayerVenue,
  FindPlayerAvailabilitySlot,
  FindPlayerRequestVenue,
  FindPlayer,
} from 'components/Find/types';

/**
 * Tabs on the /find discovery page. The value is what appears in the `tab`
 * query param, e.g. /find?tab=players
 */
export enum FindTab {
  Games = 'games',
  Players = 'players',
  Courts = 'courts',
}

export const DEFAULT_FIND_TAB = FindTab.Games;

export const isFindTab = (value: unknown): value is FindTab =>
  Object.values(FindTab).includes(value as FindTab);

/** A location picked from the address search, used to scope what /find shows. */
/** A venue on the Live courts tab — reuses CardVenue plus live-occupancy stats. */
export interface FindLiveCourt {
  id: string;
  slug: string;
  title: string;
  /** e.g. "Brooklyn, New York" */
  addressString: string;
  imageUrl?: string;
  accessType: VenueAccessTypesEnum;
  totalCourtCount: number;
  pickleballNets: VenueNetsEnum;
  primarySport?: SportsEnum;
  /** Live-occupancy counts — no schema field backs these yet (see notes). */
  onSiteNow: number;
  goingLaterToday: number;
  latitude?: number;
  longitude?: number;
}
